export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        {/* Header */}
        <div className="privacy-policy-header">
          <h1>Privacy Policy</h1>
          <p className="privacy-policy-date">Last Updated: January 1, 2024</p>
        </div>

        {/* Content */}
        <div className="privacy-policy-content">
          <section className="privacy-policy-section">
            <h2>1. Introduction</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>2. Information We Collect</h2>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <ul className="privacy-policy-list">
              <li>Personal identification information</li>
              <li>Contact information</li>
              <li>Payment information</li>
              <li>Usage data</li>
            </ul>
          </section>

          <section className="privacy-policy-section">
            <h2>3. How We Use Your Information</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>4. Data Security</h2>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>5. Your Rights</h2>
            <p>
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>6. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at privacy@example.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}